export default __webpack_public_path__ + "static/media/in-progress.80f33063.png";